export default {
	ONBOARDING: 'onboarding',
	DASHBOARD: 'dashboard',
	ACCOUNTANCY: 'accountancy',
	INVOICES: 'invoices',
	TRANSACTIONS: 'transactions',
	STATEMENTS: 'statements',
	PARTNERS: 'partners',
	LENDING: 'lending',
	FAKTORING: 'faktoring',
	HELP: 'help',
	INBOX: 'inbox',
	COREITEMS: 'core-items',
	POS: 'pos',
	TRANSACTIONS_V2: 'transactions-v2'
};
